<template>
  <div>
  <div class="card card-custom gutter-b">
    <div class="card-header border-0 py-5">
      <h3 class="card-title align-items-start flex-column">
        <span class="card-label font-weight-bolder text-dark">{{$t('ECOMMERCE.CART_OVERVIEW')}}</span>
      </h3>
      <div class="filter">
         <b-form-group id="input-group-2" label="" label-for="input-2">
          <b-form-input
            id="input-2"
            v-model="form.name"
            v-on:keyup="(e) => FilterData(e.target.value)"
            :placeholder="$t('TRANSLATOR.SEARCH')"
          ></b-form-input>
        </b-form-group>
      </div>
    </div>

    <div class="card-body" v-if="this.list.length >= 1">
      <div class="table-responsive">
        <table class="table table-head-custom table-vertical-center">
            <thead>
                <tr>
                    <th style="min-width: 40px; max-width: 60px"></th>
                    <th style="min-width: 80px">{{ $t('ECOMMERCE.PRODUCTS') }}</th>
                    <th style="min-width: 50px; max-width: 100px" class="text-center">{{ $t('ECOMMERCE.QTY') }}</th>
                    <th style="min-width: 50px; max-width: 90px" class="text-right">{{ $t('ECOMMERCE.SU') }}</th>
                    <th style="min-width: 50px; max-width: 90px" class="text-right">{{ $t('ECOMMERCE.PU') }}</th>
                    <th style="min-width: 50px; max-width: 90px" class="text-right">{{ $t('ECOMMERCE.TOTAL') }}</th>
                    <th style="min-width: 40px; max-width: 50px" class="text-right">{{ $t('ECOMMERCE.DELETE') }}</th>
                </tr>
            </thead>
            <tbody>
              <template v-for="(item, i) in list">
                <tr v-bind:key="i">
                    <td class="align-items-center font-weight-bolder">
                        <!--begin::Symbol-->
                        <div class="symbol symbol-40 flex-shrink-0 bg-light">
                          <img :src="item.url" @click="GoToProduct(`${item.category}/${item.code}`)" style="cursor: pointer;" />
                          <!-- <div class="symbol-label" style="background-image: url('/metronic/theme/html/demo2/dist/assets/media/products/11.png')"></div> -->
                        </div>
                        <!--end::Symbol-->
                    </td>
                    <td class="align-middle">
                        <a @click="GoToProduct(`${item.category}/${item.code}`)" href="javascript:void(0)" class="text-dark text-hover-primary">{{ item.name }}<br>
                        <span>({{ item.category }}) Code : {{ item.code }}</span></a>
                    </td>
                    <td class="text-center">
                      <a @click="UpdateCart(i,-1)" href="javascript:;" class="btn btn-xs btn-light-success btn-icon mr-2"><i class="ki ki-minus icon-xs"></i></a>
                      <span class="mr-2 font-weight-bolder">{{ item.quantity }}</span>
                      <a @click="UpdateCart(i,+1)" href="javascript:;" class="btn btn-xs btn-light-success btn-icon"><i class="ki ki-plus icon-xs"></i></a>
                    </td>
                    <td class="text-right align-middle">
                      x {{ item.minOrderQty }}
                    </td>
                    <td class="text-right align-middle">
                        € {{ item.price }}
                    </td>
                    <td class="text-right align-middle font-weight-bolder">
                        € {{ formatNumbers(item.price * (item.quantity * item.minOrderQty)) }}
                    </td>
                    <td class="text-right align-middle">
                        <a @click="RemoveFromCart(i)" href="javascript:;" class="btn btn-xs btn-light-danger btn-icon mr-2">
                          <i class="ki ki-bold-close icon-xs"></i>
                        </a>
                    </td>
                </tr>
                </template>
                <tr>
                    <td colspan="5" class="font-weight-bolder text-right">{{$t('ECOMMERCE.SUBTOTAL')}}</td>
                    <td class="font-weight-bolder text-right">€ {{ formatNumbers(getCartTotal) }}</td>
                    <td></td>
                </tr>
                <tr>
                    <td colspan="7" class="border-0 text-muted text-right pt-0">{{ $t('ECOMMERCE.EX_VAT_DELIVERY_MSG') }}</td>
                </tr>
                <tr>
                    <td colspan="4" class="border-0 pt-10">
                      <div class="form-group mb-3">
                          <textarea ref="note" class="form-control form-control-lg form-control-solid" type="text"
                            v-model="note" rows="2"
                            :placeholder="$t('ECOMMERCE.ADD_ORDER_NOTE')" />
                          <!-- <span class="form-text text-muted">{{ note }}</span> -->
                      </div>
                    </td>
                    <td colspan="3" class="border-0 text-right pt-10">
                        <a @click="PlaceOrderNow" href="javascript:void(0)" class="btn btn-success font-weight-bolder px-8">{{ $t('ECOMMERCE.PLACE_ORDER_NOW') }}</a>
                    </td>
                </tr>
            </tbody>
        </table>
      </div>
    </div>
    <!-- IF CART IS EMPTY -->
    <div v-if="this.list.length < 1" class="scroll scroll-push">
        <div class="d-flex align-items-center justify-content-between p-8">
          <div class="d-flex flex-column mr-2">
            <span class="text-muted">
              {{ $t('ECOMMERCE.CART_IS_EMPTY') }}
            </span>
          </div>
        </div>
    </div>
    <div class="row" v-if="loading">
      <div class="col-md-12">
        <div class="text-center">
          <b-spinner variant="primary" label="Text Centered"></b-spinner>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import axios from 'axios';
import { LOGOUT } from "@/core/services/store/auth.module";

export default {
  name: "home",
  components: {
    // KTWidget2,
  },  
   data() {
     return {
        loading: false,
        note: '',
        list: [],
        filterData: [],
        form: {
          name: "",
        },
      }
    },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Checkout" }]);
    this.loading = true;
    axios.get('/shop/getcart').then(response => {
        // console.log(response.data);
        this.list = response.data;
        this.loading = false;
      })
      .catch(err => {
          this.$store
        .dispatch(LOGOUT)
        .then(() => this.$router.push({ name: "login" }));
        throw err
        })
  },
  computed:{
    getCartTotal() {
      const total = this.list.reduce((sum, item) => {
        sum += item.price * (item.quantity * item.minOrderQty);
        return sum;
      }, 0);
      return Number((total).toFixed(2));
    },
  },
  methods: {
    formatNumbers: function(value) {
      return Number(value).toLocaleString('nl-NL', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
    });
    },
    FilterData: function (e) {
      if (e.length >= 3) {
        let newData = this.filterData.filter(
          (item) =>
            item.name.includes(e) || item.code.includes(e)
        );
        this.list = newData;
      }
      if (e.length == 0) {
        this.list = this.list;
      }
    },
    UpdateCart(i,Qty) {
      // console.log(this.list[i]);
      if(this.list[i].quantity + Qty >= 0){
        axios
          .post("shop/updatecart", {
              Id: this.list[i].id,
              Quantity: this.list[i].quantity + Qty,
          })
          .then(() => {
              // console.log(response.data);
              // this.productAdded = true;
              axios.get('/shop/getcart').then(response => {
                  // console.log("test");
                  // console.log(response.data);
                  this.list = response.data;
                  this.loading = false;
              })
              .catch((err) => {
                throw err;
              });
          })
          .catch((err) => {
            throw err;
          });
      }
    },
    RemoveFromCart(i) {
      // console.log(this.list[i]);
      axios
        .post("shop/removefromcart", {
            Id: this.list[i].id,
        })
        .then(() => {
            // console.log(response.data);
            // this.productAdded = true;
            axios.get('/shop/getcart').then(response => {
                // console.log(response.data);
                this.list = response.data;
                // this.$emit('statusChange')
                this.loading = false;
            })
            .catch((err) => {
              throw err;
            });
        })
        .catch((err) => {
          throw err;
        });
    },
    GoToProduct(url){
      this.$router.push({ path: "/shop/" + url });
    },
    PlaceOrderNow(){
        // console.log(this.list);
        axios
          .post("shop/placeorder", {
              Price: this.getCartTotal,
              Name: this.note,
              Products: this.list,
          })
          .then(() => {
              // console.log(response.data);
              this.$router.push({ path: "/orders/"});
          })
          .catch((err) => {
            throw err;
          });
    },
    HandleChange(e) {
      this.note = e.target.value;
    },
  }
};
</script>
